import * as React from 'react';
import { Quantity } from "../../../../../rest/Misc";
import { Select } from "../../../../../components/Select";
import { intToString, stringToInt } from "../../../../../converters/converters";
import { assertNumber, assertTrue } from "../../../../utils/assert/index";

interface Props
{
    quantityId: number;
    quantities: Quantity[];
    disabled?: boolean;

    setQuantity: (quantityId: number, unitId: number)  => void;
}

const getDisplay = (quantity: Quantity) => quantity.Name;
const getKey = (quantity: Quantity) => intToString(quantity.Id);

export const QuantitySelector: React.SFC<Props> = (props: Props) => {
    const { quantityId, quantities } = props;
    
    return (
        <Select className='form-control'
            disabled={props.disabled}
            placeholder='---'
            items={quantities}
            defaultValue={intToString(quantityId)}
            valueFn={getKey}
            titleFn={getDisplay}
            onChange={s => {
                const { quantities, setQuantity } = props; 
                const quantityId = stringToInt(s.getValue());
                assertNumber(quantityId, 'quantityId has to be a number');
                assertTrue(quantities.length > 0, 'at this point quantities have to be loaded');
                const quantity = quantities.find(item => item.Id === quantityId);
                assertTrue(quantity != null, `quantity with id ${quantityId} is not present in loaded values`);
                setQuantity(quantityId, quantity.Units[0]);
            }}/>
    );
};


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/EditCreateSensor/QuantitySelector.tsx